<template>
  <StudentVariant />
</template>

<script>
import StudentVariant from "../components/StudentVariant.vue";

export default {
  name: "StudentVariantView",

  components: {
    StudentVariant,
  },
};
</script>
